import React from 'react';
import './App.css';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import EditorialBoard from './components/EditorialBoard';
import Officers from './components/Officers';
import Contact from './components/Contact';
import Footer from './components/Footer';

function App() {
  return (
    <div className="App">
      <Navbar />
      <Hero />
      <About />
      <EditorialBoard />
      <Officers />
      <Contact />
      <Footer />
    </div>
  );
}

export default App;
